<template>
  <div>
    <nav
      class="v-navbar"
      role="navigation"
      aria-label="main navigation">
      <router-link
        class="navbar-item not-mobile"
        exact
        to="/"><metis-logo/></router-link>
      <span
        class="navbar-item is-mobile"
        @click="showMobile = !showMobile"><metis-logo/></span>
      <menu-content
        :left-routes="leftRoutes"
        :logout="logout"
        :right-routes="rightRoutes"
        :me="me"
      />
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      ><div
        v-if="showMobile"
        @click="showMobile = false"
        class="background-mobile"/></transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated slideInLeft"
        leave-active-class="animated slideOutLeft"
      ><nav-menu-mobile
        v-if="showMobile"
        @close="showMobile = false"
        :left-routes="leftRoutes"
        :logout="logout"
        :right-routes="rightRoutes"
        :me="me"
      /></transition>
    </nav>
  </div>
</template>
<style scoped>
.animated {
  animation-duration: 0.2s;
}
.background-mobile {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}
</style>
<style lang="scss">
.v-navbar {
  z-index: 10;
  display: flex;
  -webkit-box-shadow: 0px 3px 17px 2px rgba(0, 0, 0, 0.27);
  -moz-box-shadow: 0px 3px 17px 2px rgba(0, 0, 0, 0.27);
  box-shadow: 0px 3px 17px 2px rgba(0, 0, 0, 0.27);

  .is-mobile {
    display: none;
  }
  @media screen and (max-width: 700px) {
    .is-mobile {
      display: inherit;
    }
    .not-mobile {
      display: none;
    }
    .navbar-item {
      text-decoration: none;
      /*padding: 10px;*/
      height: inherit !important;
    }
  }
  .navbar-item {
    text-decoration: none;
    /*padding: 10px;*/
    height: 100%;
    &:hover {
      background-color: #ffffff;
      color: #ffad67;
    }
  }
}
</style>
<script>
import { actions, getApiData } from "vuex-api";
import { mapState } from "vuex";
import { routes } from "router";
import MetisLogo from "../ui/metis-logo.vue";
import MenuContent from "./menu-content";
import NavMenuMobile from "./menu-content-mobile";

export default {
  components: { NavMenuMobile, MenuContent, MetisLogo },
  name: "NavMenu",
  methods: {
    logout: function() {
      this.$store.commit(actions.clear, "me");
      localStorage.removeItem("token");
    }
  },
  computed: mapState({
    me: getApiData("me")
  }),
  data: function() {
    return {
      leftRoutes: routes.filter(nav => nav.leftNavTitle),
      rightRoutes: routes.filter(nav => nav.rightNavTitle),
      showMobile: false
    };
  }
};
</script>
